module.exports = __webpack_public_path__ + "img/qywh5.99ecb7b0.jpg";